import React from "react";

const StrategyAssessmentMainOne = () => {
    return (
        <div>
            {/* UPPER PART  */}
            <div className="row mx-0">
                <div className="col-3 text-center">
                    <div className=" p-2 shadow-lg rounded" style={{background: "#E6E6E6"}}>
                        <p>Revenue Growth Target</p>
                        <h1 className="text-success">25%</h1>
                        <p>Benchmark 0%</p>
                        <p>Obserivation</p>
                        <p className="bg-danger text-white">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Corrupti nisi ipsam distinctio magni
                            explicabo. At laboriosam culpa hic aspernatur
                            suscipit.
                        </p>
                    </div>
                </div>
               

                <div className="col-3 text-center">
                    <div className=" p-2 shadow-lg rounded" style={{background: "#A0D1FF"}}>
                        <p>Revenue Growth Target</p>
                        <h1 className="text-success">25%</h1>
                        <p>Benchmark 0%</p>
                        <p>Obserivation</p>
                        <p className="bg-danger text-white">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Corrupti nisi ipsam distinctio magni
                            explicabo. At laboriosam culpa hic aspernatur
                            suscipit.
                        </p>
                    </div>
                </div>

               

                <div className="col-3 text-center">
                    <div className=" p-2 shadow-lg rounded" style={{background: "#F5C4AF"}}>
                        <p>Revenue Growth Target</p>
                        <h1 className="text-success">25%</h1>
                        <p>Benchmark 0%</p>
                        <p>Obserivation</p>
                        <p className="bg-danger text-white">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Corrupti nisi ipsam distinctio magni
                            explicabo. At laboriosam culpa hic aspernatur
                            suscipit.
                        </p>
                    </div>
                </div>

                

                <div className="col-3 text-center">
                    <div className=" p-2 shadow-lg rounded" style={{background: "#C499CA"}}>
                        <p>Revenue Growth Target</p>
                        <h1 className="text-success">25%</h1>
                        <p>Benchmark 0%</p>
                        <p>Obserivation</p>
                        <p className="bg-danger text-white">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Corrupti nisi ipsam distinctio magni
                            explicabo. At laboriosam culpa hic aspernatur
                            suscipit.
                        </p>
                    </div>
                </div>
            </div>

            {/* BOTTOM PART+ */}

            <div className="row mx-3 mt-3 text-center">
                <div className="col-4 border border-dark">
                    <div className="p-2">
                        <h3 className="text-primary">Vision and Mission</h3>
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing
                            elit. Maiores obcaecati fuga doloribus. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                        <p className="my-1">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Veniam illum sunt adipisci! , amet consectetur
                            adipisicing elit. Maiores obcaecati fuga doloribus.
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Beatae cumque labore assumenda. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                    </div>
                </div>
                <div className="col-4 border border-dark">
                    <div className="p-2">
                        <h3 className="text-primary">Vision and Mission</h3>
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing
                            elit. Maiores obcaecati fuga doloribus. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                        <p className="my-1">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Veniam illum sunt adipisci! , amet consectetur
                            adipisicing elit. Maiores obcaecati fuga doloribus.
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Beatae cumque labore assumenda. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                    </div>
                </div>
                <div className="col-4 border border-dark">
                    <div className="p-2">
                        <h3 className="text-primary">Vision and Mission</h3>
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing
                            elit. Maiores obcaecati fuga doloribus. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                        <p className="my-1">
                            Lorem, ipsum dolor sit amet consectetur adipisicing
                            elit. Veniam illum sunt adipisci! , amet consectetur
                            adipisicing elit. Maiores obcaecati fuga doloribus.
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Beatae cumque labore assumenda. , amet
                            consectetur adipisicing elit. Maiores obcaecati fuga
                            doloribus.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StrategyAssessmentMainOne;
